import React from 'react';
import { client } from 'shared';
import EditIcon from '@mui/icons-material/Edit';
import { useModalsContext } from 'ModalsContext';
import draftPresetMap from './Drafts/draftPresetMap';
import { TextButton } from 'library/ui';

export const EditDraft = ({ jobId, onClose }: { jobId: number; onClose: () => void }) => {
    const { openJobForm } = useModalsContext();

    const clickHandler = () => {
        client(`api/ongoing/${jobId}/get-draft/`).then((draft) => {
            const jobFormPresets = draftPresetMap(draft);
            openJobForm('Edit Draft', jobFormPresets, onClose);
        });
    };

    return (
        <TextButton onClick={clickHandler}>
            <EditIcon id="more-options-edit-draft" sx={{ fontSize: 16 }} />
            Edit Draft
        </TextButton>
    );
};
